import { useQuery } from 'react-query';

import { CommonCarrierService } from '../api';

export const GetCarrierLabelsInfosQuery = 'GetCarrierLabelsInfosQuery';

export const useGetCarrierLabelsInfosQuery = ({
  fileId,
}: {
  fileId?: string;
}) => {
  const { data: carriersLabels, isLoading } = useQuery(
    [GetCarrierLabelsInfosQuery, { fileId }],
    async () => {
      if (!fileId) {
        return undefined;
      }

      const response = await CommonCarrierService.getCarrierLabelsInfosQuery({
        fileId,
      });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      suspense: true,
      staleTime: 1_000,
    },
  );

  return {
    carriersLabels,
    isLoading,
  };
};
